import { render, staticRenderFns } from "./MainNavSidebar.vue?vue&type=template&id=1190d3cf&"
import script from "./MainNavSidebar.vue?vue&type=script&lang=js&"
export * from "./MainNavSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports